import React, { Component } from 'react'
import {CheckboxStyle} from './../../styles'

export default class Checkbox extends Component {
  state = {
    checked: false
  }

  componentDidMount() {
    this.setState({ checked: this.props.checked })
    if ( this.props.checked ) this.props.onCallback({checked: true, value: this.checkbox.value})
  }

  componentWillReceiveProps({checked}) {
    if ( this.props.checked !== checked ) {
      this.setState({ checked: checked })
      this.props.onCallback({checked: checked, value: this.checkbox.value})
    }
  }

  handlerChange = (e) => {
    this.setState({ checked: e.currentTarget.checked })
    this.props.onCallback({checked: e.currentTarget.checked, value: e.currentTarget.value})
  }

  render() {
    const { children, name, id, value, className } = this.props 
    const { checked } = this.state 
    return(
      <div className={`${className} checkbox ${CheckboxStyle(checked) }`}>
        <input type="checkbox" name={name} id={id} value={value || 1} checked={checked} onChange={this.handlerChange} ref={(checkbox) => this.checkbox = checkbox} />
        <label htmlFor={id} className="checkbox-label">
          {children}
        </label>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Form/Checkbox.js